import moment from 'moment';

// A fixed heartbeat interval is used for calculations
export const HEARTBEAT_INTERVAL_MINUTES = 15;

// Sanitises the comma separated input and returns the sample values, with the
// current event value as the newest (first) sample.
export const parseSampleInput = (inputSamplesText, eventValue, maxSamples, decimals = 1) => {
    // Replace everything except numerics
    const sanitisedInput = inputSamplesText.replace(/[^0-9\.\,\-/\s]+/g, ''); // eslint-disable-line no-useless-escape
    const trimmedInput = sanitisedInput.replace(/\s+/g, ''); // Trim input for spaces
    const samples = trimmedInput.split(',').filter(Boolean);
    samples.unshift(eventValue.toFixed(decimals)); // Include event value as first sample
    samples.splice(maxSamples); // Ignore elements after we hit the sample limit

    return { sanitisedInput, samples };
};

// Builds the [{value, sampleTime}] array for an event, oldest sample last.
// Timestamps are either explanatory (<Now - 5m>) for the preview, or actual
// ISO 8601 timestamps for the published event. `transformValue` lets callers
// convert to the unit the API expects.
export const buildSamples = (samples, { useDummyTimestamps = false, transformValue = value => value } = {}) => {
    const sampleInterval = HEARTBEAT_INTERVAL_MINUTES / samples.length;
    const sampleIntervalDuration = moment.duration(sampleInterval, 'minutes');
    const formattedSampleInterval = `${sampleIntervalDuration.minutes()}m ${sampleIntervalDuration.seconds()}s`;

    const output = [];
    samples.forEach((sample, index) => {
        if (sample === '') {
            return;
        }

        // Calculate offset from event timestamp
        const sampleTimeOffset = HEARTBEAT_INTERVAL_MINUTES - (sampleInterval * (samples.length - index));
        const duration = moment.duration(sampleTimeOffset, 'minutes');

        let sampleTime;
        if (useDummyTimestamps) {
            sampleTime = index === 0 ? '<Now>' : `<Now - ${duration.minutes()}m ${duration.seconds()}s>`;
        } else {
            sampleTime = index === 0 ? moment().toISOString() : moment().subtract(duration).toISOString();
        }

        output.push({
            value: transformValue(Number(sample)),
            sampleTime
        });
    });

    return { samples: output, formattedSampleInterval };
};

// Comma separated values centered around the event value, for the quick-fill buttons.
export const randomSampleInput = (count, eventValue, decimals = 1) => {
    let inputSamplesText = '';
    for (let i = 0; i < count; i++) {
        const sample = Math.sin((i + 1) / 2) + eventValue; // Values are +/- 0.5
        inputSamplesText += `${sample.toFixed(decimals)}, `;
    }
    return inputSamplesText;
};
